import { Segmented } from "antd";
import { useState } from "react";
import { AcademicData, SemisterData } from "./data";

export const AcademicDetails = (props) => {
  const { dataId, academicId } = props;
  const [activeTab, setActiveTab] = useState("academic");
  

  return (
    <>
      <div className="container-fluid">
        <div className="row mb-2">
          <div className="col-12">
            <p className="h2 fw-bold text-custom">Academic Details</p>
          </div>
          <hr className="mt-3" />
        </div>
        <div className="row">
          <div className="col-12">
            <div className="card shadow border-red p-3">
              <Segmented
                size="middle"
                className="pt-2 ps-2 pe-2 pb-0"
                block
                onChange={(e) => setActiveTab(e)}
                options={[
                  {
                    label: "Academic Info",
                    value: "academic",
                    icon: <i className="bi bi-box fs-5" />,
                  },
                  {
                    label: "Semister",
                    value: "semister",
                    icon: <i className="bi bi-boxes fs-5" />,
                  },
                  {
                    label: "Time Table",
                    value: "table",
                    icon: <i className="bi bi-person fs-5" />,
                  },
                ]}
              />
            </div>
          </div>
        </div>
        <div className="row mt-0">
          <div className="col-12">
            {activeTab === "academic" && <AcademicData dataId={dataId} />}
            {activeTab === "semister" && (
              <SemisterData dataId={dataId} academicId={academicId} />
            )}
          </div>
        </div>
      </div>
    </>
  );
};
